import { render, staticRenderFns } from "./cookie-alert.vue?vue&type=template&id=4a751a60&scoped=true&"
import script from "./cookie-alert.vue?vue&type=script&lang=js&"
export * from "./cookie-alert.vue?vue&type=script&lang=js&"
import style0 from "./cookie-alert.vue?vue&type=style&index=0&id=4a751a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a751a60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VRow})
